import { render } from "./FooterFeedbackNew.vue?vue&type=template&id=37ab083e&scoped=true"
import script from "./FooterFeedbackNew.vue?vue&type=script&lang=js"
export * from "./FooterFeedbackNew.vue?vue&type=script&lang=js"

import "./FooterFeedbackNew.vue?vue&type=style&index=0&id=37ab083e&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ab083e"]])

export default __exports__